export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as putCoveragesKey,
  initialState as putCoveragesInitialState,
  State as PutCoveragesState,
} from './reducer';

export {
  getData as putCoveragesGetData,
  getError as putCoveragesGetError,
  getLoading as putCoveragesGetLoading,
  mapData as putCoveragesMapData,
} from './selectors';
